import { Loader2 } from "lucide-react";

/**
 * Minimal loading indicator shown while Clerk / AuthContext hydrate.
 * Replaces the previous heavy feature-carousel loading screen that
 * could feel "stuck" and block users from reaching the sign-in form.
 */
export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFFDF7]">
      <Loader2
        className="w-8 h-8 animate-spin text-[#14C8B0]"
        strokeWidth={2.5}
      />
    </div>
  );
}
